import { datasource } from './datasource';

export const thumbCutDS = (databaseAlias, currentUserId, actions) => () =>
  datasource(databaseAlias, currentUserId, actions)('thumb_cut', {
    model: {
      id: 'id',
      auditable: true,
      syncable: true,
      byProshop: true,
      //                byProshopSQL: 'SELECT t1.* FROM -tablename- AS t1, spec_sheet AS t3, customer_proshop AS t2 WHERE t1.spec_sheet_id = t3.id AND t3.customer_id = t2.customer_id AND t2.proshop_id = "-proshopId-"',
      byProshopSQL:
        'SELECT t1.* FROM -tablename- AS t1, spec_sheet AS t3, customer_proshop AS t2 WHERE t1.spec_sheet_id = t3.id AND t3.customer_id = t2.customer_id AND t1.spec_sheet_id = "-specsheetId-"',
      fields: {
        id: {
          type: 'string',
        },
        spec_sheet_id: {
          type: 'string',
        },
        cut_number: {
          type: 'number',
        },
        v: {
          type: 'string',
        },
        h: {
          type: 'string',
        },
        label: {
          type: 'string',
          alter: true,
        },
        created_at: {
          type: 'string',
        },
        updated_at: {
          type: 'string',
        },
        created_by: {
          type: 'string',
        },
        updated_by: {
          type: 'string',
        },
      },
    },
  });
